import { Provider } from '@angular/core';

import { PtrabSessionRepositoryImpl } from '@app/data/repositories/ptrab/session/session.repository';
import { PTRAB_SESSION_REPOSITORY } from '@app/domain/repositories/ptrab/session/session.repository.contract';

export const ptrabSessionRepositoryProvider: Provider = {
  provide: PTRAB_SESSION_REPOSITORY,
  useClass: PtrabSessionRepositoryImpl
};
